import { baseApi } from "../baseApi";

export const nebulaStatsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStats: builder.query({
      query: ({ type = "paper", tab = "composite" } = {}) => ({
        url: `/api/personalize/nebula-brain/stats`,
        params: { type, assetClass: tab },
      }),
      transformResponse: (res) => res,
      providesTags: ["PortfolioStats"],
    }),
    getReturns: builder.query({
      query: ({ type = "paper", tab = "composite" } = {}) => ({
        url: `/api/personalize/nebula-brain/returns`,
        params: { type, assetClass: tab },
      }),
      transformResponse: (res) => res,
    }),
    getPositionsOpen: builder.query({
      query: ({
        type = "paper",
        tab = "composite",
        mode = "AVCO",
        page = 0,
        size = 20,
      } = {}) => ({
        url: `/api/personalize/nebula-brain/positions/open`,
        params: { type, assetClass: tab, mode, page, size },
      }),
      transformResponse: (res) => res,
    }),
    getPositionsClosed: builder.query({
      query: ({
        type = "paper",
        tab = "composite",
        mode = "AVCO",
        page = 0,
        size = 20,
      } = {}) => ({
        url: `/api/personalize/nebula-brain/positions/closed`,
        params: { type, assetClass: tab, mode, page, size },
      }),
      transformResponse: (res) => res,
    }),
    getTransactions: builder.query({
      query: ({
        type = "paper",
        tab = "composite",
        page = 0,
        size = 20,
      } = {}) => ({
        url: `/api/personalize/nebula-brain/transactions`,
        params: { type, assetClass: tab, page, size },
      }),
      transformResponse: (res) => res,
    }),
    getTransactionsByTicker: builder.query({
      query: ({ ticker, type = "paper", tab = "composite" }) => ({
        url: `/api/personalize/nebula-brain/transactions/${ticker}`,
        params: { type, assetClass: tab },
      }),
      transformResponse: (res) => res,
    }),
    getDecisions: builder.query({
      query: ({ type = "backtest", decision, page = 0, size = 10 } = {}) => ({
        url: `/api/personalize/nebula-brain/decisions`,
        params: { type, decision, page, size },
      }),
      transformResponse: (res) => res,
    }),
    getDecisionDetail: builder.query({
      query: (id) => ({
        url: `/api/personalize/nebula-brain/decisions/${id}`,
      }),
      transformResponse: (res) => res,
    }),
    getDecisionExplain: builder.query({
      query: (decisionId) => ({
        url: `/api/personalize/nebula-brain/decisions/explain/${decisionId}`,
      }),
      transformResponse: (res) => res,
    }),
    getHoldings: builder.query({
      query: ({ type = "backtest", assetClass = "composite", tier } = {}) => ({
        url: `/api/personalize/nebula-brain/holdings`,
        params: { type, assetClass, ...(tier ? { tier } : {}) },
      }),
      transformResponse: (res) => res,
      providesTags: ["PortfolioStats"],
    }),
    getHedgeDrawdownPeriods: builder.query({
      query: ({ type = "paper" } = {}) => ({
        url: "/api/personalize/nebula-brain/hedge/effective",
        params: { type },
      }),
      transformResponse: (res) => res,
    }),
    getHedgePositionsClosed: builder.query({
      query: ({
        type = "paper",
        closeReason,
        period,
        page = 0,
        size = 5,
      } = {}) => ({
        url: "/api/personalize/nebula-brain/hedge/positions/closed",
        params: { type, closeReason, period, page, size },
      }),
      transformResponse: (res) => res,
    }),
    getHedgeReturns: builder.query({
      query: ({ type = "paper", tab = "composite" } = {}) => ({
        url: "/api/personalize/nebula-brain/hedge/returns",
        params: { type, assetClass: tab },
      }),
      transformResponse: (res) => res,
    }),
    getMarginInterestHistory: builder.query({
      query: ({ type = "paper", page = 0, size = 5 } = {}) => ({
        url: "/api/personalize/nebula-brain/margin/history",
        params: { type, page, size },
      }),
      transformResponse: (res) => res,
    }),
    getMarginInterestSeries: builder.query({
      query: ({ type = "paper" } = {}) => ({
        url: "/api/personalize/nebula-brain/margin/interest",
        params: { type },
      }),
      transformResponse: (res) => res,
    }),
    updateProfile: builder.mutation({
      query: (profile) => ({
        url: "/api/personalize/nebula-brain/profiles/update",
        method: "POST",
        body: profile,
      }),
      invalidatesTags: ["PortfolioStats"],
    }),
    convertIntegration: builder.mutation({
      query: () => ({
        url: "/api/personalize/nebula-brain/profiles/convert-integration",
        method: "POST",
      }),
      invalidatesTags: ["PortfolioStats"],
    }),
    rollbackIntegration: builder.mutation({
      query: () => ({
        url: "/api/personalize/nebula-brain/profiles/rollback-integration",
        method: "POST",
      }),
      invalidatesTags: ["PortfolioStats"],
    }),
  }),
});

export const {
  useGetStatsQuery,
  useGetReturnsQuery,
  useGetPositionsOpenQuery,
  useGetPositionsClosedQuery,
  useGetTransactionsQuery,
  useGetTransactionsByTickerQuery,
  useGetDecisionsQuery,
  useGetDecisionDetailQuery,
  useGetDecisionExplainQuery,
  useGetHoldingsQuery,
  useGetHedgeDrawdownPeriodsQuery,
  useGetHedgePositionsClosedQuery,
  useGetHedgeReturnsQuery,
  useGetMarginInterestHistoryQuery,
  useGetMarginInterestSeriesQuery,
  useUpdateProfileMutation,
  useConvertIntegrationMutation,
  useRollbackIntegrationMutation,
} = nebulaStatsApi;
